
export enum SubscriptionStatus {
    Active = 'Active',
    GracePeriod = 'GracePeriod',
    Cancelled = 'Cancelled',
    Revoked = 'Revoked'
}
